// Banner
export const getBannerItemList = banner =>
    banner && banner.list && banner.list.items
        ? banner.list.items
        : [];

export const getShowBanner = banner =>
    banner && banner.showBanner && banner.showBanner
        ? banner.showBanner
        : false;

export const getBannerLoading = banner =>
    banner && banner.loading && banner.loading
        ? banner.loading
        : false;

export const getBannerItem = items =>
    items && items ? items.map(items => items.id) : null;

export const getBannerImage = items =>
    items && items.large && items.large.src ? items.large.src : [];



// WEBPACK FOOTER //
// ./src/selectors/banner.js